module.exports = __webpack_public_path__ + "static/media/person.022ff959.svg";